import { render, staticRenderFns } from "./TagsTabSidebar.vue?vue&type=template&id=73c859cb&scoped=true"
import script from "./TagsTabSidebar.vue?vue&type=script&lang=js"
export * from "./TagsTabSidebar.vue?vue&type=script&lang=js"
import style0 from "./TagsTabSidebar.vue?vue&type=style&index=0&id=73c859cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c859cb",
  null
  
)

export default component.exports